import { useEffect, useState } from 'react';
import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { getCommitTriggerSetting } from './utils';

function CommitButton(props) {
  const { projectId, disabled = false, onClick } = props;
  const { t } = useTranslation(['icp-components']);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!projectId) return;
    getCommitTriggerSetting(projectId).then((result) => setVisible(!!result));
  }, [projectId]);

  if (!visible) {
    return null;
  }

  return (
    <Tooltip
      title={disabled ? t('commit-content.tooltip-disabled') : t('commit-content.tooltip-enabled')}
    >
      <Button disabled={disabled} onClick={onClick}>
        {t('commit-content.title')}
      </Button>
    </Tooltip>
  );
}

CommitButton.propTypes = {
  projectId: PropTypes.number,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default CommitButton;
